//global host
export const HOST = "https://api.srvr2px.cyberads.io/cm_chatgpt";
export const HOST2 = "https://api.srvr2px.cyberads.io/cm_seo_content"